import {
  GridFilterModel,
  GridPaginationModel,
  GridSortModel,
} from '@mui/x-data-grid';
import { createSlice } from '@reduxjs/toolkit';

// Set defaults here
export const initialState: {
  filterModel: GridFilterModel;
  sortModel: Array<GridSortModel[number]>;
  paginationModel: GridPaginationModel;
} = {
  filterModel: {
    items: [],
  },
  sortModel: [],
  paginationModel: {
    page: 0,
    pageSize: 100,
  },
};

const quoteTableModelsSlice = createSlice({
  name: `quoteTableModels`,
  initialState,
  reducers: {
    setFilterModel: (state, action) => {
      const parsed = action.payload.items.map(item => {
        if (item.value instanceof Date) {
          // Serialise using the local calendar date (not toISOString, which shifts
          // to UTC and can move the selected day across the date boundary)
          const date = item.value;
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, `0`);
          const day = String(date.getDate()).padStart(2, `0`);

          return {
            ...item,
            value: `${year}-${month}-${day}`,
          };
        }

        return item;
      });
      action.payload.items = parsed;
      state.filterModel = action.payload;
    },
    setSortModel: (state, action) => {
      state.sortModel = action.payload;
    },
    setPaginationModel: (state, action) => {
      state.paginationModel = action.payload;
    },
    reset: () => initialState,
    resetSort: state => {
      state.sortModel = initialState.sortModel;
    },
    resetFilter: state => {
      state.filterModel = initialState.filterModel;
    },
    resetPagination: state => {
      state.paginationModel = initialState.paginationModel;
    },
  },
});

export const {
  setFilterModel,
  setSortModel,
  setPaginationModel,
  reset,
  resetSort,
  resetFilter,
  resetPagination,
} = quoteTableModelsSlice.actions;

export const quoteTableModelsReducer = quoteTableModelsSlice.reducer;
